module.exports = __webpack_public_path__ + "b6f3910731a5cea8979769de810b1c25.pdf";